import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useUser } from '../../../context/UserContext';
import { useOrganization } from '../../../context/OrganizationContext';

const TopBar = () => {
  const { userInfo } = useUser();
  const { organizationData } = useOrganization();
  const location = useLocation();

  const getOrganizationDetails = () => {
    if (!organizationData) return { name: "Loading..." };
    return { 
      name: organizationData.name || organizationData.agency_name || organizationData.organization_name || "Unknown Organization"
    };
  };

  const getCurrentPageName = () => {
    if (location.pathname.includes('/threads')) return 'Threads';
    if (location.pathname.includes('/report')) return 'Report';
    if (location.pathname.includes('/pivot')) return 'Pivot';
    if (location.pathname.includes('/alerts')) return 'Alerts';
    if (location.pathname.includes('/settings')) return 'Account';
    return 'Dashboard';
  };

  const { name } = getOrganizationDetails();

  return (
    <div className="h-8 bg-white/60 backdrop-blur-sm border-b border-gray-50 flex items-center px-6">
      {/* Breadcrumb with Organization Switching */}
      <Link 
        to="/home" 
        className="flex items-center gap-1 text-xs text-gray-500 no-underline transition-all duration-200 hover:bg-gray-50 rounded px-1.5 py-0.5"
        title="Switch organization"
      >
        <span className="font-medium text-gray-700 hover:text-primary">{name}</span>
        <span>›</span>
        <span>{getCurrentPageName()}</span>
      </Link>
    </div>
  );
};

export default TopBar;